import * as React from "react";
import DocumentTitle from "react-document-title";
import Grid from "@material-ui/core/Grid";
import { observer } from "mobx-react-lite";
import { SupervisorsProfilesTable } from "../../features/Tables/SupervisorsProfilesTable/SupervisorsProfilesTable";
import { UserRoleEnum } from "../../static/enums/UserRole";
import { useGetUsers } from "../../helpers/hooks/useGetUsers";
import { uiStore } from "../../mobx/stores/UiStore/UiStore";

export const SupervisorsProfilesPage = observer(() => {
  const { loading } = uiStore;
  useGetUsers({
    role: UserRoleEnum.supervisor,
  });

  return (
    <DocumentTitle title={"Кураторы - Mindset.Digital"}>
      <Grid container spacing={3}>
        <SupervisorsProfilesTable loading={loading} />
      </Grid>
    </DocumentTitle>
  );
});
